import "./LeftDrawer.scss"
import close from "../../assets/close.svg"
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import Button from "../button/Button";

const LeftDrawer = ({ isOpen, setIsOpen }) => {

    const history = useHistory()
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const Components = [
        {
            "ID": "SuvaiNavbar-Navbar",
            "Order": 1,
            "Type": "",
            "Props": {
                "href": "/",
                "src": "https://storage.googleapis.com/eco_image/witmeg/apps/OnlineOrder/DosaNChutney/logo%20(3).png"
            }
        },
        {
            "ID": "SuvaiNavbar-Navbar-link",
            "Order": 2,
            "Type": "links",
            "Props": null,
            "Data": [
                {
                    "href": "/",
                    "title": "home"
                },
                {
                    "href": "/about",
                    "title": "about"
                }, {
                    "href": "/menu",
                    "title": "menus"
                }, {
                    "href": "/gallery",
                    "title": "gallery"
                }, {
                    "href": "/contact",
                    "title": "contact"
                }
            ]
        },
        {
            "ID": "SuvaiNavbar-Navbar-button",
            "Order": 3,
            "Type": "button",
            "Props": {
                "buttonText": "Book a table",
                "href": ""
            }
        }
    ]
    const pages = Components?.find((component) => component?.ID === "SuvaiNavbar-Navbar-link")?.Data ?? []
    const buttonComponent = Components?.find((component) => component?.ID === "SuvaiNavbar-Navbar-button")?.Props ?? null

    return (
        <div className="Suvai">
            <div className={`Suvai-left-drawer ${isOpen ? 'open' : ''}`}>
                <div className={`Suvai-left-drawer-header`}>
                    <img alt="" src={close}
                        onClick={() => {
                            setIsOpen(false)
                        }} />
                </div>
                <div className={`Suvai-left-drawer-content`}>
                    {pages.map((page, key) => {
                        return (
                            <>
                                <div className={`Suvai-left-drawer-content-pages  ${window.location.pathname === page?.href ? "PapayaLeft-link-selected " : ""}`} key={key}
                                    onClick={() => {
                                        setIsOpen(false)
                                        if (page?.href) {
                                            if (page?.href?.includes("https://")) {
                                                if (page?.href && page?.href !== "") {
                                                    window.open(page?.href, '_blank')
                                                }
                                            } else {
                                                history.push(page?.href)
                                            }
                                        }

                                    }}>
                                    {page?.title}

                                </div>
                            </>
                        )
                    })}
                    {buttonComponent && <div className={`Suvai-left-drawer-content-btn`}>
                        <Button
                            text={buttonComponent?.buttonText}
                            onClick={() => {
                                if (buttonComponent?.href && buttonComponent?.href !== "") {
                                    window.open(buttonComponent?.href, '_blank')
                                }
                            }}
                        />
                    </div>}
                </div>
                <div className="Suvai-left-drawer-bottm">
                    <div className="Suvai-left-drawer-bottm-header">
                        ADDRESS
                    </div>
                    <div className="Suvai-left-drawer-bottm-item">
                        {companyDetails?.address?.line1},  {companyDetails?.address?.city}, {companyDetails?.address?.postcode}, {companyDetails?.address?.state}
                    </div>
                    <div className="Suvai-left-drawer-bottm-item2">
                        P: <b> {companyDetails?.contactNumber}</b>
                    </div>
                    <div className="Suvai-left-drawer-bottm-item2">
                        E: <b> {companyDetails?.email}</b>
                    </div>
                </div>

            </div>
        </div>
    )
}
export default LeftDrawer